import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["side", "withControl", "withCounter", "count", "onButtonClick", "className", "position"];
import { IconChevronLeft, IconChevronRight } from '@carnica/graphics';
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { Text } from "../../Text";
import styles from "./styles.pcss";
var cnTabBarBlurArea = cnBem('blur-area', styles);
export var TabBarBlurArea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$side = _ref.side,
    side = _ref$side === void 0 ? 'left' : _ref$side,
    withControl = _ref.withControl,
    withCounter = _ref.withCounter,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    onButtonClick = _ref.onButtonClick,
    className = _ref.className,
    position = _ref.position,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Icon = side === 'left' ? IconChevronLeft : IconChevronRight;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnTabBarBlurArea({
      side: side,
      position: position
    }, [className]),
    ref: ref
  }, otherProps, {
    "data-t-id": "TabBar-TabBarBlurArea"
  }), withControl && /*#__PURE__*/React.createElement(Icon, {
    "aria-label": "\u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 ".concat(side === 'left' ? 'начало' : 'конец'),
    className: cnTabBarBlurArea('button'),
    color: "tertiary",
    onClick: onButtonClick,
    size: "s",
    tagName: "button",
    type: "button"
  }), withCounter && count > 0 && /*#__PURE__*/React.createElement(Text, {
    className: cnTabBarBlurArea('counter'),
    color: "tertiary",
    variant: "body-small"
  }, "\u2022 ".concat(count)));
});